import React, { ReactElement } from 'react'

export interface ErrorPageProps {
  pageContext: LAW.Helpers.IPageContext
}

export default function ErrorPage({}: ErrorPageProps): ReactElement {
  return <div>404</div>
}
